"use client";

import MDEditor from "@uiw/react-md-editor";

import "@uiw/react-md-editor/markdown-editor.css";
import "@uiw/react-markdown-preview/markdown.css";

export default function RenderBlog({ markDownData }) {
  return (
    <>
      {markDownData && (
        <div>
          <MDEditor.Markdown
            style={{ backgroundColor: "transparent", color: "black" }}
            source={markDownData}
          />
        </div>
      )}
    </>
  );
}
